export const menu = {
	sideMenu: {
		en: [
			{ id: 1, label: 'Home', target : 'intro'},
			{ id: 2, label: 'Who we are', target : 'one'},
			{ id: 3, label: 'What we do', target : 'two'},
			{ id: 4, label: 'About the event', target : 'four'},
			{ id: 6, label: 'Supporters', target : 'five'},
			{ id: 5, label: 'Sign up', target : 'three'},
		],
		fi: [
			{ id: 1, label: 'Home', target : 'intro'},
			{ id: 2, label: 'Menu 1', target : 'one'},
			{ id: 3, label: 'Menu 2', target : 'two'},
			{ id: 4, label: 'Menu 3', target : 'three'},
			{ id: 6, label: 'Menu 4', target : 'five'},
			{ id: 5, label: 'Menu 5', target : 'four'},
		]
	},
	languages: [
		{
			key: 'fi', iso: 'fi', slug: 'fi', en: 'Finnish', fi: 'Suomi',
		},
		{
			key: 'en', iso: 'gb', slug: 'en', en: 'English', fi: 'Englanti',
		},
	],
	getSideMenu: () => menu.sideMenu,
	getAllLanguages: () => menu.languages,
}
